<template>
  <v-tooltip top>
    <template #activator="{on}">
      <v-btn v-on="on" @click="open" download :href="url" :loading="loading" target="_blank" class="ma-0" icon flat>
        <v-icon color="primary" class="theme--light">download</v-icon>
      </v-btn>
    </template>
    <strong v-html="$t('message.metadata.download')"></strong>
  </v-tooltip>
</template>

<script>
export default {
  name: 'nx-video-rendition-download',
  props: {
    url: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    filename() {
      return this.url.substring(this.url.lastIndexOf('/') + 1);
    },
  },
  methods: {
    open() {
      window.open(this.url);
    },
    async download() {
      this.loading = true;
      const res = await fetch(this.url, {
        method: 'GET',
      });

      const blob = await res.blob();
      const newBlob = new Blob([blob]);

      const blobUrl = window.URL.createObjectURL(newBlob);

      const link = document.createElement('a');
      link.href = blobUrl;
      link.setAttribute('download', this.filename);
      document.body.appendChild(link);
      link.click();
      link.parentNode.removeChild(link);

      window.URL.revokeObjectURL(blobUrl);
      this.loading = false;
    },
  },
};
</script>
